import axios from "axios";
import { URL_HOST } from "const/CommonConst";

const CURRENT_SERVICE = `${URL_HOST}Oficinas`;

const OficinaService = {
  getAll: async () => {
    try {
      const result = await axios.get(
          `${CURRENT_SERVICE}`);
      return result.data;
    } catch (error) {
      console.error(error.message);

      throw error;
    }
  },  
};

export default OficinaService;
